module.exports = __webpack_public_path__ + "img/clouds-with-lighting-rain.12b788b7.png";